<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>医院信息化软件</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">医院信息化软件</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        启秘一体化医院信息综合管理系统提供医院全面业务信息管理工具，
        覆盖了医院主要管理职能和病人就诊的所有主要环节，支持医院经济管理，临床医疗管理和决策支持三大管理中心，
        提供了实现大中型医院信息化的全面解决方案。包括医院管理信息系统（HIS）、
        实验室管理信息系统（LIS）、影像归档和通讯系统（PACS）。<br><br>
        <span class="con_text">医院信息管理系统：</span>
        <br>
        ·护士工作站模块<br>
        ·库房进销存管理模块<br>
        ·医保接口模块<br>
        ·门诊医生工作站模块<br>
        ·住院医师工作站模块<br>
        ·医疗健康信息集成模块<br>
        ·门急诊挂号模块<br>
        ·住院结算系统模块<br>
        ·与其他系统接口模块<br>
        ·门急诊收费模块 综合查询模块<br><br>
        <span class="con_text">临床检验系统：</span>
        <br>
        ·检验申请模块<br>
        ·标本接受模块<br>
        ·标本检验审核报告发布模块<br>
        ·标本采集模块<br>
        ·标本后处理模块<br>
        ·检验设备数据采集模块<br>
        ·标本登记模块<br>
        ·质量控制模块<br>
        ·与其他系统接口模块<br><br>
        <span class="con_text">服务器及存储系统：</span>
        <br>
        ·PACS 设备连接模块<br>
        ·ACS/RIS、超声 / 心电图 /X 光机工作站软件<br>
        ·数据存储归档系统<br>
        ·与其他系统接口模块<br><br>
        <span class="con_text">特点 / 技术指标：</span>
        <br>
        1、先进的管理思想，快捷的运行速度；<br>
        2、新老系统平滑过渡、无缝衔接，方便维护和升级；<br>
        3、一体化设计，与 LIS、电子病历、PACS 等系统无缝连接；<br>
        4、解支持 DICOM3.0 及 HL7V2.5、HL7V3.0 标准、SCP-ECG 标准、ICD-10 标准；<br>
        5、符合 IHE 技术框架中关于 RTF 集成框架、PCC 技术框架、ITI 技术框架中的主要业务及数据流程，支持以及 LIS 集成框架；<br>
        6、适用于二级和一级中小医疗机构，包括县、区级医院及区县级以下的医疗机构；<br>
        7、采用全国统一版本、标准化套装软件包，统一升级免个性化修改；<br>
        8、一次性部署，周期短、见效快；<br>
        7、简化系统维护工作，一个电话，解决三大系统的维护难题<br><br>
      </p>
      <!-- <div class="con_img"><img src="../../assets/img/Product7s.png" /></div> -->
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 40%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>